import {isNil} from 'ramda';

import {FinancingCompositionScene} from '@dms/api/shared';

import {Nullish} from 'shared/web';

// A missing background and a background with opacity 0 both let the gallery show through.
export const isTransparentBackground = (
  background: FinancingCompositionScene['canvas']['background'] | Nullish
): boolean => isNil(background) || background.opacity === 0;
